import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=4947729e&scoped=true&"
import script from "./PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./PasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./PasswordEdit.vue?vue&type=style&index=0&id=4947729e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947729e",
  null
  
)

export default component.exports